import React from "react";
import Proptypes from "prop-types";
import alphabet from "../../../helpers/alphabet";
import CustomSelect from "../../ui/CustomSelect";

const AlphabetFilters = function (props) {
  // Empty option label toggles:
  // - No letter selected -> "Fund name"
  // - Letter selected    -> "All"
  var emptyLabel = props.letter ? "(show all)" : "Fund name A-Z";

  // Build options: dynamic empty + A–Z (disable letters not in activeLetters)
  var options = [{ value: "", label: emptyLabel }];
  for (var i = 0; i < alphabet.length; i++) {
    var l = alphabet[i];
    var enabled =
      props.activeLetters &&
      props.activeLetters.indexOf(String(l).toUpperCase()) >= 0;

    options.push({
      value: l,
      label: String(l).toUpperCase(),
      disabled: !enabled
    });
  }

  return (
    <fieldset className="AlphabetFilter ListingFilters-group">
      {props.showLegend ? (
        <legend className="f-label-small">Filter By Letter</legend>
      ) : null}

      <CustomSelect
        id="letter-select"
        value={props.letter || ""}
        onChange={function (val) { props.setLetters(val); }}
        placeholder="Fund name"
        options={options}
        className="c-select"
        triggerClassName="c-select__trigger"
        menuClassName="c-select__menu"
        optionClassName="c-select__option"
        ariaLabel="Filter by first letter"
      />
    </fieldset>
  );
};

AlphabetFilters.propTypes = {
  activeLetters: Proptypes.arrayOf(Proptypes.string),
  setLetters: Proptypes.func.isRequired,
  letter: Proptypes.string,
  showLegend: Proptypes.bool
};

export default AlphabetFilters;
